/**
 * @generated SignedSource<<6a3036582425dfdc32dd542e87bf2b7d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NewsfeedWeb_widgetNewsfeed$data = {
  readonly posts: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"WidgetNewsfeedPost_widgetNewsfeedPost">;
  }>;
  readonly " $fragmentType": "NewsfeedWeb_widgetNewsfeed";
};
export type NewsfeedWeb_widgetNewsfeed$key = {
  readonly " $data"?: NewsfeedWeb_widgetNewsfeed$data;
  readonly " $fragmentSpreads": FragmentRefs<"NewsfeedWeb_widgetNewsfeed">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NewsfeedWeb_widgetNewsfeed",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "WidgetNewsfeedPost",
      "kind": "LinkedField",
      "name": "posts",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetNewsfeedPost_widgetNewsfeedPost"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetNewsfeed",
  "abstractKey": null
};

(node as any).hash = "13be2eb6ee05c4d50e99feffb2722bb8";

export default node;
